import PropTypes from "prop-types";
import React, { useState } from "react";
import Textarea from "@components/_Layout/Controls/Textarea";
import toast from "react-hot-toast";
import { useCart } from "@hooks";

type ObservationBlockProps = {};

const ObservationBlock: React.FC<ObservationBlockProps> = ({}) => {
  /* Hooks */
  const { cart, addObservation } = useCart();

  /* State */
  const [observation, setObservation] = useState<string>(
    cart?.reservations?.map((x) => x?.observation).join(", ")!!
  );

  const handleAddObservation = () => {
    const cartItemIds: number[] | null =
      cart?.reservations?.map((x) => x?.cartItemID!!) ?? null;
    if (cartItemIds) {
      addObservation(observation, cartItemIds, (err) => {
        if (err) toast.error(err.message);
      });
    }
  };

  return (
    <div>
      <Textarea
        onChange={(e) => setObservation(e.target.value)}
        value={observation}
        additionalClassname="tw-w-full"
        rows={4}
        onBlur={handleAddObservation}
      />
    </div>
  );
};

ObservationBlock.propTypes = {
  title: PropTypes.string.isRequired,
};

export default ObservationBlock;
